var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52849 3.41676C3.70463 3.27437 3.93568 3.2192 4.15715 3.26665L9.33333 4.37584L14.5095 3.26665C14.6131 3.24446 14.7202 3.24446 14.8238 3.26665L20.1571 4.40951C20.503 4.48361 20.75 4.78921 20.75 5.14286V20C20.75 20.2265 20.6476 20.4409 20.4715 20.5833C20.2954 20.7256 20.0643 20.7808 19.8429 20.7334L14.6667 19.6242L9.49048 20.7334C9.38689 20.7556 9.27978 20.7556 9.17619 20.7334L3.84285 19.5905C3.49705 19.5164 3.25 19.2108 3.25 18.8572V4.00001C3.25 3.77351 3.35235 3.55915 3.52849 3.41676ZM15.4167 18.2508L19.25 19.0723V5.74918L15.4167 4.92775V18.2508ZM13.9167 4.92775V18.2508L10.0833 19.0723V5.74918L13.9167 4.92775ZM8.58333 5.74918L4.75 4.92775V18.2508L8.58333 19.0723V5.74918Z",
    fill: "#1E1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/Ic_Map.163083233f458d0ee4a9bccfdacc279a.svg";
export { ForwardRef as ReactComponent };